<script lang="ts">
	let { link, text }: { link: string; text: string } = $props();
</script>

<li>
	<a href={link} class="text-background/50 hover:text-background text-sm/6 transition">{text}</a>
</li>
